import actionTypes from './actionTypes';

const INITIAL_STATE = {
  cafeTables: [],
  getTablesByCafeIdLoading: false,
  getTablesByCafeIdFailed: false,
  getTablesByCafeIdError: false,
  getTablesByCafeIdMessage: null,
  getTablesByCafeIdFailedMessagesList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_TABLES_BY_CAFE_ID_LOADING: {
      return {
        ...state,
        getTablesByCafeIdLoading: true,
        getTablesByCafeIdFailed: false,
        getTablesByCafeIdError: false,
        getTablesByCafeIdMessage: '',
        getTablesByCafeIdFailedMessagesList: [],
        cafeTables: []
      };
    }
    case actionTypes.GET_TABLES_BY_CAFE_ID_SUCCESS: {
      return {
        ...state,
        getTablesByCafeIdLoading: false,
        getTablesByCafeIdFailed: false,
        getTablesByCafeIdError: false,
        getTablesByCafeIdMessage: '',
        getTablesByCafeIdFailedMessagesList: [],
        cafeTables: [...action.payload]
      };
    }
    case actionTypes.GET_TABLES_BY_CAFE_ID_FAILED: {
      const { message, errors } = action.payload;
      return {
        ...state,
        getTablesByCafeIdLoading: false,
        getTablesByCafeIdFailed: true,
        getTablesByCafeIdError: false,
        getTablesByCafeIdMessage: message,
        getTablesByCafeIdFailedMessagesList: errors || [],
        cafeTables: []
      };
    }
    case actionTypes.GET_TABLES_BY_CAFE_ID_REJECT: {
      return {
        ...state,
        getTablesByCafeIdLoading: false,
        getTablesByCafeIdFailed: false,
        getTablesByCafeIdError: true,
        getTablesByCafeIdMessage: '',
        getTablesByCafeIdFailedMessagesList: [],
        cafeTables: []
      };
    }
    case actionTypes.CLEAR_CAFE_TABLES_LIST_DATA: {
      return {
        ...state,
        getTablesByCafeIdLoading: false,
        getTablesByCafeIdFailed: false,
        getTablesByCafeIdError: false,
        getTablesByCafeIdMessage: '',
        getTablesByCafeIdFailedMessagesList: [],
        cafeTables: []
      };
    }

    default:
      return state;
  }
};
